import React from 'react';
import { useTranslation } from '../../i18n';
import { GameConfig } from '../../config/types';
import { GamePremiumBadge } from '../shared/GamePremiumBadge';
import { AppIcon, getGameIconName } from '../shared/icons';

export interface GameCarouselTileProps {
  game: GameConfig;
  isSelected: boolean;
  voteCount: number;
  isMonthlyFree: boolean;
  isPremium: boolean;
  selectedAccent: { color: string; rgb: string };
  onClick: () => void;
  onPremiumClick?: () => void;
  tileRef?: (el: HTMLDivElement | null) => void;
}

export const GameCarouselTile: React.FC<GameCarouselTileProps> = ({
  game,
  isSelected,
  voteCount,
  isMonthlyFree,
  isPremium,
  selectedAccent,
  onClick,
  onPremiumClick,
  tileRef,
}) => {
  const { t } = useTranslation();
  const classes = ['game-tile', isSelected ? 'game-tile-selected' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div
      ref={tileRef}
      className={classes}
      onClick={onClick}
      style={{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ['--game-accent' as any]: game.color,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ['--game-selection-accent' as any]: selectedAccent.color,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ['--game-selection-accent-rgb' as any]: selectedAccent.rgb,
      }}
      data-game-id={game.id}
    >
      {isPremium && (
        <GamePremiumBadge isMonthlyFree={isMonthlyFree} onPremiumClick={onPremiumClick} />
      )}
      <div className="game-tile-content-wrapper">
        <div className="game-tile-body">
          <div className="game-tile-icon" aria-hidden="true">
            <AppIcon name={getGameIconName(game.id)} />
          </div>
          <h3 className="game-tile-title">{game.name}</h3>
          <p className="game-tile-description">{game.description}</p>
          {voteCount > 0 && (
            <div className="game-tile-votes">
              {voteCount} {t(voteCount === 1 ? 'common.vote_one' : 'common.vote_other')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
